import { css, SerializedStyles } from '@emotion/core';
import { Theme, inlineButton } from 'features/Theme';

const styles = {
  underline: (theme: Theme): SerializedStyles => css`
    ${inlineButton(theme)}
  `,
  noUnderline: (theme: Theme): SerializedStyles => css`
    ${inlineButton(theme)}
    text-decoration: none;
  `,
};

export default styles;
